// base
import { useMemo } from 'react';

// modules
import { UserInfoAtom } from 'modules';

// services
import { cookieStorage } from 'services';

// routes
import { ROUTE_SIGN_IN } from 'routes/const.js';

// libraries
import { useRecoilValue, useResetRecoilState } from 'recoil';

export const useUser = () => {
  const userInfo = useRecoilValue(UserInfoAtom);
  const resetUserInfo = useResetRecoilState(UserInfoAtom);

  const isLogin = useMemo(() => !!userInfo || false, [userInfo]);

  const onLogout = () => {
    window.location.href = ROUTE_SIGN_IN;

    cookieStorage.clearAllCookies();
    resetUserInfo();
  };

  return { userInfo, setUserInfo: resetUserInfo, isLogin, onLogout };
};
